import { jsx as a } from "react/jsx-runtime";
const i = ({
  ratio: e = "aspect-video",
  children: t = "LOADING...",
  ...r
}) => /* @__PURE__ */ a(
  "div",
  {
    className: `${e} bg-gray-200 animate-pulse rounded-lg py-[21px] pl-[28px] pr-6 relative mb-[10px] text-gray-500 flex items-center justify-center`,
    ...r,
    children: t
  }
);
export {
  i as LoadingCard
};
